<template>
    <div class="category-show">
        <div class="category-show__header">
            <div class="category-show__header-left">
                <div class="category-show__drag-handle"></div>
                <div
                    class="category-show__display-mode-toggle"
                    @click.stop="toggleFullDisplayMode"
                    v-html="isFullDisplayMode ? $tc('icons.carret-up') : $tc('icons.carret-down')"
                ></div>
                <div @click.stop="toggleFullDisplayMode" class="category-show__title">{{ category.name }}</div>
            </div>
            <div @click="destroyCategory" v-html="$tc('icons.delete')"></div>
        </div>
        <div v-if="isFullDisplayMode" class="category-show__body">
            <draggable
                class="app__category-applications-list"
                v-model="categoryVersionsApplications"
                :group="categoryApplicationsGroup"
                @change="changeApplications"
                @start="isManagingVersions = true"
                @end="isManagingVersions = false"
            >
                <application-thumb
                    v-for="application in categoryVersionsApplications"
                    :key="application.id"
                    :application="application"
                ></application-thumb>
            </draggable>

            <draggable class="app__applications-remove-zone" :group="trashApplicationsGroup" v-if="isManagingVersions">
                {{ $tc("categories.removeApplications") }}
            </draggable>
        </div>
    </div>
</template>

<script>
import ApplicationThumb from "./ApplicationThumb.vue";
import draggable from "vuedraggable";
import {store} from "atom";

const {createNamespacedHelpers} = store;
const {mapActions, mapState} = createNamespacedHelpers("arcman");

export default {
    name: "category-show",
    props: {
        id: {
            default() {
                return this._uid;
            },
        },
        category: {
            type: Object,
            required: true,
        },
        project: {
            type: Object,
            required: true,
        },
    },
    components: {
        ApplicationThumb,
        draggable,
    },
    data: () => {
        return {
            categoryVersionsApplications: [],
            isFullDisplayMode: true,
            isManagingVersions: false,
        };
    },
    computed: {
        ...mapState(["applications"]),
        categoryApplicationsGroup() {
            return {
                name: `categoryApplicationsGroup-${this.id}`,
                pull: true,
                put: ["projectApplicationsGroup", `categoryApplicationsGroup-${this.id}`],
            };
        },
        trashApplicationsGroup() {
            return {
                name: "trashApplicationsGroup",
                put: true,
                pull: false,
            };
        },
    },
    methods: {
        ...mapActions({
            deleteCategory: "DELETE_CATEGORY",
            swapCategoryVersions: "SWAP_CATEGORY_VERSIONS",
        }),
        destroyCategory() {
            this.$modal.dialog(this.$t("categories.confirmDelete", {name: this.category.name})).then(confirm => {
                if (confirm) {
                    this.deleteCategory({project: this.project, category: this.category});
                }
                this.$modal.hide();
            });
        },
        changeApplications(event) {
            let uniqueCategoryVersions = new Set(this.categoryVersionsApplications);
            this.categoryVersionsApplications = Array.from(uniqueCategoryVersions);
            let categoryVersions = this.categoryVersionsApplications.map(
                element => element.versions[element.currentVersionIndex]
            );
            this.swapCategoryVersions({
                projectId: this.project.id,
                categoryId: this.category.id,
                versions: categoryVersions,
            });
        },
        toggleFullDisplayMode() {
            this.isFullDisplayMode = !this.isFullDisplayMode;
        },
    },
    created() {
        this.categoryVersionsApplications = this.category.versions.map(version => {
            const application = this.applications.find(element => element.id === version.application.id);
            return application;
        });
    },
};
</script>

<style lang="scss" scoped>
.category-show {
    @apply w-full relative rounded-lg my-2;
    background-color: $background-application-color;
    border: 1px solid $border-card-color;

    .category-show__header {
        @apply flex items-center justify-between pt-2 px-5;
    }

    .category-show__header-left {
        @apply flex items-center justify-between;
    }

    .category-show__display-mode-toggle {
        &:hover {
            @apply cursor-pointer;
        }
    }

    .category-show__title {
        @apply px-4;
        &:hover {
            @apply cursor-pointer underline;
        }
    }

    .category-show__body {
        @apply w-full py-2 px-4;
    }

    .category-show__drag-handle {
        @apply cursor-move bg-contain bg-no-repeat;
        width: 2rem;
        height: 2rem;
        background-image: url(../assets/images/dragHandle.png);

        &:hover {
            @apply border-l-4;
        }
    }
}
</style>
